
import React from 'react';
import { SparkleIcon } from './icons/SparkleIcon';

const TopBanner: React.FC = () => {
  return (
    <div className="bg-gradient-to-r from-[#2ECC40] to-green-400 text-white text-center p-2 text-sm font-semibold flex items-center justify-center gap-2">
      <SparkleIcon className="w-4 h-4" />
      <span>Money saved is money earned. Start your forgiveness journey today!</span>
    </div>
  );
};

export default TopBanner;
